import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button as MuiButton,
	Drawer,
	Link,
	Paper,
	Stack,
} from '@mui/material'

import { styled } from '@mui/material/styles'

import React, { useState } from 'react'
import {
	APP_BASE_URL,
	ART_CRAFT,
	ART_CRAFT_URL,
	BENEFIT,
	BENEFIT_URL,
	CONTACT,
	CONTACT_URL,
	DIARY,
	DIARY_URL,
	DIY,
	DIY_URL,
	EMPLOYMENT_SUPPORT,
	EMPLOYMENT_SUPPORT_URL,
	GIFT_OBJECT,
	GIFT_OBJECT_URL,
	HISTORY,
	HISTORY_URL,
	PROJECTS,
	PROJECTS_URL,
	RECOVERY_WORKSHOP,
	RECOVERY_WORKSHOP_URL,
	REFERENCE_TEAM,
	REFERENCE_TEAM_URL,
	SHOP,
	SHOP_URL,
} from '../../constants'
import { ReactComponent as BurgerBlack } from '../../media/burgerBlack.svg'
import { ReactComponent as BurgerWhite } from '../../media/burgerWhite.svg'
import Button from '../atoms/Button'

import { ReactComponent as Arrow } from '../../media/accordion-arrow-white.svg'

const Puller = styled(Box)(({ theme }) => ({
	width: 60,
	height: 4,
	backgroundColor: '#6D6D6D',
	border: 0,
	borderRadius: 3,
	position: 'absolute',
	top: 12,
	left: 'calc(50% - 30px)',
}))

const MobileMenu = ({ window, white }) => {
	const drawerBleeding = 56
	const [open, setOpen] = useState(false)

	const toggleDrawer = (newOpen) => () => {
		setOpen(newOpen)
	}

	// This is used only for the example
	const containerMobileMenu = window !== undefined ? () => window().document.body : undefined

	return (
		<Box
			sx={{
				textAlign: 'center',
				pt: 0,
				color: 'black',

				'&.css-1ci1yhx-MuiPaper-root-MuiDrawer-paper': {
					background: 'transparent',
				},
			}}
			className="burger"
		>
			<MuiButton onClick={toggleDrawer(true)} sx={{ color: 'black', p: 0, minWidth: 2 }}>
				{(white && <BurgerWhite />) || <BurgerBlack />}
			</MuiButton>
			<Drawer
				container={containerMobileMenu}
				anchor="bottom"
				open={open}
				onClose={toggleDrawer(false)}
				onOpen={toggleDrawer(true)}
				swipeAreaWidth={drawerBleeding}
				sx={{ '& .MuiDrawer-paper': { background: 'transparent' } }}
			>
				<Paper
					sx={(theme) => ({
						bgcolor: 'text.secondary',
						borderRadius: '20px 20px 0 0',
						p: theme.spacing(5, 3),
					})}
				>
					<Box>
						<Stack
							sx={(theme) => ({
								'& a': {
									display: 'block',
									fontSize: 16,
									fontWeight: 700,
									border: 0,
									textDecoration: 'none',
									p: theme.spacing(2, 0),

									borderTop: `1px solid ${theme.palette.text.white}`,

									'&:first-of-type': {
										border: 'none',
									},

									'&:hover': {
										textDecoration: 'none',
										cursor: 'pointer',
										color: 'secondary.main',
									},
								},
							})}
						>
							<Puller />
							<Accordion sx={{ backgroundColor: 'transparent' }}>
								<AccordionSummary
									expandIcon={<Arrow />}
									sx={{
										color: 'white',
										fontWeight: 700,
										pl: 0,
										'&:hover': { color: 'secondary.main' },
									}}
								>
									La collecterie
								</AccordionSummary>
								<AccordionDetails>
									<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${DIARY_URL}`}>
										{DIARY}
									</Link>

									<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${HISTORY_URL}`}>
										{HISTORY}
									</Link>
									<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${REFERENCE_TEAM_URL}`}>
										{REFERENCE_TEAM}
									</Link>
									<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${EMPLOYMENT_SUPPORT_URL}`}>
										{EMPLOYMENT_SUPPORT}
									</Link>
									<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${PROJECTS_URL}`}>
										{PROJECTS}
									</Link>
								</AccordionDetails>
							</Accordion>

							<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${GIFT_OBJECT_URL}`}>
								{GIFT_OBJECT}
							</Link>
							<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${SHOP_URL}`}>
								{SHOP}
							</Link>
							<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${RECOVERY_WORKSHOP_URL}`}>
								{RECOVERY_WORKSHOP}
							</Link>
							<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${ART_CRAFT_URL}`}>
								{ART_CRAFT}
							</Link>
							<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${BENEFIT_URL}`}>
								{BENEFIT}
							</Link>
							<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${DIY_URL}`}>
								{DIY}
							</Link>
							<Button
								href={`${APP_BASE_URL}${CONTACT_URL}`}
								label={CONTACT}
								bgColor="blue"
								color="white"
								ml="1"
								mt={4}
								noBorder={true}
							/>
						</Stack>
					</Box>
				</Paper>
			</Drawer>
		</Box>
	)
}

export default MobileMenu
